import { createAsyncThunk } from '@reduxjs/toolkit'
import Preferences from './preferences-model'
import {
  delete_preferences,
  load_preferencess,
  store_preferences,
} from './preferences-service'

export const LoadPreferencessAsync = createAsyncThunk<any, any>(
  'composer/load/preferences',
  async (params: { uid: string }) => {
    return await load_preferencess(params)
  },
)

export const CreatePreferencesAsync = createAsyncThunk<any, any>(
  'composer/create/preferences',
  async (params: Preferences) => {
    return await store_preferences(params)
  },
)

export const DeletePreferencesAsync = createAsyncThunk<any, any>(
  'composer/delete/preferences',
  async (params) => {
    return await delete_preferences(params)
  },
)
